import { render, staticRenderFns } from "./planning_index.vue?vue&type=template&id=638524d0&scoped=true&"
import script from "./planning_index.vue?vue&type=script&lang=js&"
export * from "./planning_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638524d0",
  null
  
)

export default component.exports